import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import { disciplines, getProducts } from '@util/discipline'

import type { Project } from '../../project/types/Project'

import { DisciplineVerzameling } from './DisciplineVerzameling'

const headerCells = [
  {
    id: 'disciplineCode',
    numeric: false,
    label: 'Aangevraagde disciplines',
    sort: true,
  },
  { id: 'netbeheerderCode', numeric: false, label: 'Netbeheerder', sort: true },
  { id: 'aantalObjecten', numeric: true, label: 'Objecten', sort: true },
  {
    id: 'processtap',
    numeric: false,
    label: 'Processtap',
    sort: false,
    fixed: 150,
  },
  { id: 'opties', numeric: false, label: '', sort: true, fixed: 50 },
]

interface Props {
  project: Project
}

export const DisciplineVerzamelingen = ({ project }: Props) => {
  const { aanvraagID, disciplineVerzamelingen = [] } = project
  const getDisciplineVerzameling = getProducts(disciplineVerzamelingen)

  return (
    <TableRow>
      <TableCell colSpan={11} sx={{ p: 0, backgroundColor: '#f7f7f7' }}>
        <Table sx={{ p: 0, backgroundColor: '#f7f7f7' }}>
          <TableHead>
            <TableRow>
              {headerCells.map((headerCell) => (
                <TableCell
                  key={headerCell.id}
                  sx={{
                    width: headerCell.fixed,
                  }}
                >
                  {headerCell.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {disciplines
              .reduce(
                (curr, disciplineCode) =>
                  curr.concat(getDisciplineVerzameling(disciplineCode)),
                [],
              )
              .map((product: any) => {
                return (
                  <DisciplineVerzameling
                    key={`${aanvraagID}${product.disciplineCode}${product.netbeheerderCode}`}
                    project={project}
                    product={product}
                  />
                )
              })}
          </TableBody>
        </Table>
      </TableCell>
    </TableRow>
  )
}
